.card { display: flex; flex-direction: column; gap: 14px; min-width: 0; padding: 24px; background: var(--paper); border: var(--border-panel); }
.head { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 12px 24px; }
.headText { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.title { margin: 0; font-family: var(--font-cond); font-size: 34px; font-weight: 800; letter-spacing: -1.2px; line-height: 1; }
.sub { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.fastest { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); }
.scroll { overflow-x: auto; overscroll-behavior-x: contain; }
.scrollInner { display: flex; flex-direction: column; gap: 14px; }
.bars { display: flex; align-items: flex-end; gap: 10px; margin: 0; padding: 0; list-style: none; border-bottom: 1px solid var(--ink); }
.split { flex: 1; min-width: 0; height: 100%; }
.splitButton { display: flex; flex-direction: column; align-items: center; justify-content: flex-end; gap: 6px; width: 100%; height: 100%; padding: 0; background: none; border: 0; cursor: pointer; }
.pace { font-family: var(--font-cond); font-size: 18px; font-weight: 900; line-height: 1; color: var(--ink); }
.bar { display: block; width: 100%; border: 1px solid var(--ink); }
.splitButton[aria-pressed='true'] .bar { outline: 2px solid var(--ink); outline-offset: 1px; }
.labels { display: flex; gap: 10px; }
.label { flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: center; gap: 2px; }
.km { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.8px; color: var(--ink); }
.gap { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.4px; color: var(--sport-run); }
.note { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.6px; line-height: 1.5; color: var(--text-secondary); }

@media (max-width: 639px) {
  .card { gap: 12px; padding: 14px; }
  .title { font-size: 28px; letter-spacing: -1px; }
  .scrollInner { gap: 12px; }
  .bars, .labels { gap: 4px; }
  .splitButton { min-height: 44px; }
  .pace { font-family: var(--font-mono); font-size: 8px; font-weight: 400; }
  .km { color: var(--text-secondary); }
}
